import { FC } from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import { Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import { FilterMultiColumn } from "src/organisms/AlgoliaProductList/MobileFilterView/MobileFilters.styled";
import isLightColor from "src/utils/isLightColor";
import { RefinementListProvided } from "react-instantsearch-core";
import {
  StyledColorContainer,
  StyledColorBox,
  Check,
} from "./ColorFilter.styled";

const ColorRefinementList: FC<RefinementListProvided> = ({ items, refine }) => {
  const multicolorIconLink =
    "https://colors-icons.s3.eu-central-1.amazonaws.com/multicoloured.png";

  return (
    <Flex height="100%" flexDirection="column" justifyContent="space-between">
      <FilterMultiColumn
        isMultiColumn={items && items.length > 1}
        count={Math.round(items.length / 2)}
      >
        {items.map((item) => {
          const splitLabel = item.label.split("||");
          const label = splitLabel[1];
          const color = splitLabel[2];
          return (
            <StyledColorContainer
              key={label}
              onClick={() => {
                refine(item.value);
              }}
            >
              {color ? (
                <Flex sx={{ position: "relative" }} variant="centered">
                  <StyledColorBox backgroundColor={color} />
                  <Text as="p">{label}</Text>
                  {item.isRefined && (
                    <Check stroke={isLightColor(color) ? "#000" : "#FFF"} />
                  )}
                </Flex>
              ) : (
                <Flex sx={{ position: "relative" }} variant="centered">
                  <StyledColorBox background={multicolorIconLink} />
                  <Text as="p">{label}</Text>
                  {item.isRefined && <Check stroke={"#FFF"} />}
                </Flex>
              )}
            </StyledColorContainer>
          );
        })}
      </FilterMultiColumn>
    </Flex>
  );
};

const ColorFilter = connectRefinementList(ColorRefinementList);

export default ColorFilter;
